import { useEffect, useState } from "react";
import * as Google from "expo-auth-session/providers/google";
import * as AuthSession from "expo-auth-session";
import { axiosWithCredentials } from "../api/axios";
import useAuth from "./useAuth";
// import axiosWithCredentials from "../api/axios"; // Adjust your import path accordingly

export const useGoogleAuth = (onSuccessCallback) => {
  const { sub } = useAuth();

  const [isAuthLoading, setIsAuthLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);

  const [request, response, promptAsync] = Google.useAuthRequest({
    webClientId: "607742650924-2ei9go2bl635sl9gh1pakdj2rqr3s0kn.apps.googleusercontent.com",
    iosClientId: "607742650924-mbcms1rms9i91dj5l9cdp4143lgua83c.apps.googleusercontent.com",
    androidClientId: "607742650924-k779l559pl0hjfse5a2kch7cqh5j71jf.apps.googleusercontent.com",
    redirectUri: AuthSession.makeRedirectUri({
      scheme: "http",
      host: "localhost",
      port: 8081,
      path: "",
    }),
  });

  useEffect(() => {
    if (response?.type === "success") {
      const { authentication } = response;
      const { accessToken } = authentication;

      executeGoogleGuestSignup(accessToken);
    }
  }, [response]);

  async function executeGoogleGuestSignup(googleAuthToken) {
    if (isAuthLoading) return;

    try {
      setIsAuthLoading(true);

      const endpoint = sub
        ? "/convertGuestToGoogleAuth/convertGuestToGoogleAuth"
        : "/googleGuestAuth/googleGuestAuth";

      const authResponse = await axiosWithCredentials.post(endpoint, {
        googleToken: googleAuthToken,
        ...(sub && { guestUserId: sub }),
      });

      const strictLocalToken = authResponse.data.accessToken;

      // If a custom success callback was passed, run it (e.g. setAuth state)
      if (onSuccessCallback) {
        onSuccessCallback(strictLocalToken);
      }
    } catch (error) {
      console.error("Frontend Auth Catch Triggered:", error);

      setErrorMessage(
        error?.response?.data?.message ||
          error.message ||
          "Google authentication failed. Please try again.",
      );
      setIsErrorCompVisible(true);
    } finally {
      setIsAuthLoading(false);
    }
  }

  return {
    promptAsync,
    request,
    isAuthLoading,
    errorMessage,
    isErrorCompVisible,
    setIsErrorCompVisible,
  };
};
